var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('audio',{ref:"audio",staticClass:"aud",attrs:{"autoplay":""}},[_c('source',{attrs:{"src":"https://kyfw.12306.cn/otn/resources/js/framework/audio/message.wav"}})]),_c('infoDialog',{ref:"infoDialog",attrs:{"type":1,"title":"请立即关闭消防泵，存在以下风险告警:"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }